export const MAX_CAPTURE_WIDTH_RATIO = 0.88;
export const MAX_CAPTURE_HEIGHT_RATIO = 0.9;

/**
 * @typedef {{ width: number; height: number; left: number; top: number }} CaptureRect
 */

/**
 * Largest centred rectangle of the given aspect ratio inside the viewport,
 * capped so inactive mask bands remain visible.
 *
 * @param {number} viewportWidth
 * @param {number} viewportHeight
 * @param {number} aspectWidth
 * @param {number} aspectHeight
 * @returns {CaptureRect}
 */
export function calculateCaptureRect(viewportWidth, viewportHeight, aspectWidth, aspectHeight) {
  if (
    !Number.isFinite(viewportWidth) ||
    !Number.isFinite(viewportHeight) ||
    viewportWidth <= 0 ||
    viewportHeight <= 0 ||
    !Number.isFinite(aspectWidth) ||
    !Number.isFinite(aspectHeight) ||
    aspectWidth <= 0 ||
    aspectHeight <= 0
  ) {
    return { width: 0, height: 0, left: 0, top: 0 };
  }

  const aspect = aspectWidth / aspectHeight;
  const availableWidth = viewportWidth * MAX_CAPTURE_WIDTH_RATIO;
  const availableHeight = viewportHeight * MAX_CAPTURE_HEIGHT_RATIO;

  let width = availableWidth;
  let height = width / aspect;

  if (height > availableHeight) {
    height = availableHeight;
    width = height * aspect;
  }

  return {
    width,
    height,
    left: (viewportWidth - width) / 2,
    top: (viewportHeight - height) / 2,
  };
}
